// DS: MO 2.1
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import s from './CoreMonetizationAd.scss';
var CoreMonetizationAd = function (_a) {
    var boldText = _a.boldText, text = _a.text, withCTA = _a.withCTA;
    var t = useTranslation().t;
    return (React.createElement("div", { className: s['root'] },
        boldText && React.createElement("span", { className: s['ad-bold-text'] }, boldText),
        React.createElement("span", { className: s['ad-text'] }, text),
        withCTA && (React.createElement(TextButton, { size: "small", variant: "core-orange", href: Url.coreMembershipLink(), target: "_blank", biData: BiData({
                evid: 375,
                referral_info: ReferralType.PROFILE_SUBSCRIPTIONS,
            }) }, t('coreMonetizationAd.upgradeCTA')))));
};
CoreMonetizationAd.displayName = 'CoreMonetizationAd';
export default CoreMonetizationAd;
//# sourceMappingURL=CoreMonetizationAd.js.map